import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { AccessTokenResponse, FCLResponse, FscExternalUserResponse, User } from '../model/user';
import { OktaAuthService } from '@okta/okta-angular';
import { OktaConfig } from '@okta/okta-angular/src/okta/models/okta.config';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FclLoginService {
  loginForm: any;
  isUserLoggedIn = false;
  user: User;
  userType: string;
  notValidUser = false;
  notValidUser$ = new BehaviorSubject(this.notValidUser);

  constructor(  
    private http: HttpClient,
    private router: Router,
    public oktaAuth: OktaAuthService,
  ) {}


  fclAccessToken(): Observable<AccessTokenResponse> {

    const httpOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        grant_type: environment.fclGrantType,
        client_id: environment.fclClientId,
        // client_secret: environment.fclSecret,
        scope: environment.fclScope
      }
    };
    return this.http.post<AccessTokenResponse>(environment.fclURL + '/auth/oauth/v2/token', '', httpOptions);

  }


  fclLogin(username: string, pwd: string, accessToken: string): Observable<FCLResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
      'X-locale': 'en_US',
      'X-loggedin': 'true',
      'X-clientid': 'WCDO',
      'X-version': '1.0'
      
    });


    const options = { headers, withCredentials: true };
    const url = environment.fclURL + '/user/v2/login';
    return this.http.post<FCLResponse>(url, {
      userName: username,
      password: pwd
    }, options);

  }

  getSessionId(cookieValue: any) {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      Cookie: cookieValue
    });
    const url = environment.oktaIssuer.split('/oauth2/default');
    const callUrl = url[0] + '/api/v1/sessions/me/lifecycle/refresh';
    const options = { headers };
    return this.http.post<any>(callUrl, options);
  }

  extendfclSession(accessToken: string): Observable<FCLResponse> {

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken
    });
    const options = { headers, withCredentials: true };
    const url = environment.fclURL + '/user/v2/accounts';
    return this.http.get<any>(url, options);

  }

  validateUser(usrIdOrToken: string): Observable<FscExternalUserResponse> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      usrId: usrIdOrToken
    });
    const params = new HttpParams().append('userType', this.getUserType());
    const options = { headers, params };
    const url = environment.apiUserURL + '/validateExternalUser';
    return this.http.get<FscExternalUserResponse>(url, options);

  }

  registerUser(user: User): Observable<User> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid()
    });
    const options = { headers };
    const url = environment.apiUserURL + '/registerUser';
    return this.http.post<User>(url, user, options);
  }


  getGatewayAccessToken(): Observable<AccessTokenResponse> {

    const httpOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        grant_type: environment.apiGatewayGrantType,
        client_id: environment.apiGatewayClientId,
        client_secret: environment.apiGatewaySecret,
        scope: environment.apiGatewayScope
      }
    };
    return this.http.post<AccessTokenResponse>(environment.apiGatewayURL + '/auth/oauth/v2/token', '', httpOptions);

  }

  populateUserInfo(userObj: User) {
    const userStr = JSON.stringify(userObj);
    this.user = JSON.parse(userStr);
    localStorage.setItem('USER', userStr);

    // set userid based on type of login
    if (this.getUserType() === 'I') {
      localStorage.setItem('USERID', this.getUser().fedExId);
    } else if (this.getUserType() === 'E') {
      localStorage.setItem('USERID', this.getUser().loginId);
    } else if (this.getUserType() === 'T') {
      localStorage.setItem('USERID', this.getUser().loginId);
    }
  }

  getUser(): User {
    if (this.user !== undefined && this.user !== null) {
      return this.user;
    } else if (localStorage.getItem('USER')) {
      return JSON.parse(localStorage.getItem('USER'));
    } else {
      return new User();
    }
  }

  setUserType(userType: string) {
    localStorage.setItem('userType', userType);
  }
  getUserType() {
    if (this.userType !== undefined) {
      return this.userType;
    } else {
      return localStorage.getItem('userType');
    }
  }

  oktaSvc() {
    if (this.userType === 'I') {

      const oktaConfig = {
        issuer: environment.oktaIssuer,
        clientId: environment.oktaClientId,
        redirectUri: environment.oktaURL + '/authorization-code/callback',
        pkce: true,
        scopes: environment.oktaScopes
      };

      return oktaConfig;

    } else {
      // window.location.href = 'https://purpleid-partners-stage.oktapreview.com/';

      const oktaConfig = {
        issuer: environment.oktaTempIssuer,
        clientId: environment.oktaTempClientId,
        redirectUri: environment.oktaURL + '/authorization-code/callback',
        pkce: true
      };

      return oktaConfig;
    }
  }

  clearLocalStorage() {
    console.log('this is in service clear Locatl storage')
    this.clearDuringLogin();
    localStorage.removeItem('userType');
  }

  clearDuringLogin() {
    console.log('this is in service clear during login')
    localStorage.clear();
    localStorage.removeItem('headerTitle');
    localStorage.removeItem('USER');
    localStorage.removeItem('USERID');
    localStorage.removeItem('SelectedModule');
    localStorage.removeItem('selectedCustomer');
    localStorage.removeItem('customer_portal_modules');
    localStorage.removeItem('selected_menu');
    localStorage.removeItem('gateway-access-token');
    localStorage.removeItem('searchData');
    localStorage.removeItem('status');
  }

  //fcl user info
  getFCLUserInfo(): Observable<FCLResponse>{
    return this.http.get<FCLResponse>(environment.fclURL + '/user/v2/users/userinfo');

  }

 fclUserInfoToken(): Observable<AccessTokenResponse> {

    const httpOptions = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        grant_type: environment.fclGrantType,
        client_id: environment.fclUserInfoClientId,
        client_secret: environment.fclUserInfoSecret,
        // scope: environment.fclScope
      }
    };
    return this.http.post<AccessTokenResponse>(environment.fclURL + '/auth/oauth/v2/token', '', httpOptions);
  }
  
  updateUserAndFacilityLastLoginTime(usrId: string, selectedCustomerId: string): Observable<User> {
    const userId = usrId?.toString() || '';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      usrId: userId,
      'Access-Control-Allow-Origin': '*'
    });
    const customerId = selectedCustomerId?.toString() || '';
    const params = new HttpParams().append('selectedCustomerId', customerId);
    const options = { headers, params };
    const url = environment.apiUserURL + '/updateUserAndFacilityLoginDetails';
    return this.http.patch<User>(url , JSON.stringify(null), options);    
  }  

  updateUserLocale(usrId: string, lang: string): Observable<User> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      usrId: usrId?.toString() || '',
      'Access-Control-Allow-Origin': '*'
    });
    const userLocaleRequest = {
      'selectedLocale': lang
    };
    const options = { headers };
    const url = environment.apiUserURL + '/users/updateUserLocale';
    return this.http.patch<User>(url , JSON.stringify(userLocaleRequest), options); 
  } 
}
